// extracted by mini-css-extract-plugin
module.exports = {"PageContent":"PageContent_PageContent__2GSjX"};